import React from "react";

import type { RouterLinkProps } from "@js/components/link";
import { RouterLink } from "@js/components/link";

export const NavLink = (props: RouterLinkProps) => {
  return <RouterLink activeClassName="is-active" {...props} />;
};
